import ModalTemplate from "../ModalTemplate/ModalTemplate";
import { ReactComponent as TrashSvg } from "../../assets/trash.svg";
import Button from "../Button/Button";
import "./DeleteModal.scss"

const DeleteModal = ({ isOpen, onClose, onConfirm, title = "Deleting item", message, confirmText = "Delete" }) => {

    const footerButtons = (
        <>
            <Button onClick={onConfirm} className="delete" >
                {confirmText}
            </Button>
            <Button onClick={onClose} variant="secondary">
                Cancel
            </Button>
        </>
    );

    return (
        <ModalTemplate
            isOpen={true}
            onClose={onClose}
            title={title}
            icon={TrashSvg}
            footerActions={footerButtons}
            className="delete"
        >
            <p>{message}</p>
            <p>This action cannot be undone.</p>
        </ModalTemplate>
    );
};

export default DeleteModal;